"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("../../Link"));

var _AccountNotifications = require("./AccountNotifications.style");

var AccountNotifications = function AccountNotifications(_ref) {
  var avatarNotifications = _ref.avatarNotifications,
      variant = _ref.variant,
      toggleNav = _ref.toggleNav,
      rest = _objectWithoutProperties(_ref, ["avatarNotifications", "variant", "toggleNav"]);

  var url = avatarNotifications.url,
      counter = avatarNotifications.counter;

  if (url) {
    return /*#__PURE__*/_react.default.createElement(_AccountNotifications.Wrap, {
      variant: variant
    }, /*#__PURE__*/_react.default.createElement(_Link.default, Object.assign({
      to: url,
      onClick: function onClick() {
        toggleNav();
      },
      display: "block"
    }, rest), /*#__PURE__*/_react.default.createElement(_AccountNotifications.NotificationsIcon, {
      name: "Bell",
      color: "black"
    }), counter && /*#__PURE__*/_react.default.createElement(_AccountNotifications.Counter, {
      counter: counter
    })));
  }

  return /*#__PURE__*/_react.default.createElement(_AccountNotifications.Wrap, null, /*#__PURE__*/_react.default.createElement(_AccountNotifications.NotificationsIcon, {
    name: "Bell",
    color: "black"
  }), avatarNotifications.counter && /*#__PURE__*/_react.default.createElement(_AccountNotifications.Counter, {
    counter: avatarNotifications.counter
  }));
};

AccountNotifications.propTypes = {
  avatarNotifications: _propTypes.default.shape({
    url: _propTypes.default.string,
    counter: _propTypes.default.number
  }),
  variant: _propTypes.default.oneOf(['primary', 'mega', 'slider']),
  toggleNav: _propTypes.default.func
};
AccountNotifications.defaultProps = {
  avatarNotifications: {
    url: null,
    counter: null
  },
  variant: 'primary',
  toggleNav: null
};
var _default = AccountNotifications;
exports.default = _default;